import { createAction, props } from '@ngrx/store';

export const loadPricingInfo = createAction('[Pricing] Load Pricing Info');
export const loadPricingInfoSuccess = createAction(
    '[Pricing] Load Pricing Info Success',
    props<{ pricingInfo: any }>()
);
export const loadPricingInfoFailure = createAction(
    '[Pricing] Load Pricing Info Failure',
    props<{ error: string }>()
);

export const setPlan = createAction(
    '[Pricing] Set Plan',
    props<{ planId: string }>()
);
export const setPlanSuccess = createAction(
    '[Pricing] Set Plan Success',
    props<{ planId: string }>()
);
export const setPlanFailure = createAction(
    '[Pricing] Set Plan Failure',
    props<{ error: string }>()
);

export const togglePricingModal = createAction(
    '[Pricing] Toggle Pricing Modal',
    props<{ show: boolean }>()
); 